import { render, staticRenderFns } from "./heading.vue?vue&type=template&id=21934936&scoped=true&lang=pug&"
import script from "./heading.vue?vue&type=script&lang=coffee&"
export * from "./heading.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21934936",
  null
  
)

export default component.exports